import { AllRows, Columns, ReportData } from '../result.interface';


export function getFileExportOperatividadEquipos(ctx: any, vrs: number): any {
       
   
   var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config:Columns[] = [];

    var codigo_cell_ch_width = "codigo".length;
    var placa_cell_ch_width = "placa".length;
    var estado_cell_ch_width = "Estado GPS".length;
    var estado_cipia_cell_ch_width = "Estado Cipia".length;

    var fatiga_cell_ch_width = "Fatiga 360".length;
    var caredrive_cell_ch_width = "Caredrive".length;
    var adas_cell_ch_width = "ADAS".length;
    var can_cell_ch_width = "CAN".length;

    var nom_inf = "REPORTE DE OPERATIVIDAD DE EQUIPOS";

    var allRows: AllRows[] = [
        {
          cells: [
            { value: nom_inf, ...ctx.headerCellConfig, colSpan: 3 }
          ],
          height: ctx.headerRowsHeight,
        },
        ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
    ];

    var table_width = 9; //1 + (ctx.chkDateHour? 4:2) + 4;
    //var vehiculo_width = (ctx.chkDateHour? 4:3);

    ctx.sortedData.forEach((table_data: any) => {
      if(table_data[1].length > 0){
        column_config = [];

        bol_datos_ex = true;

        var nom_vehi = table_data[0][1];




        /* Table Header */

        var rows: AllRows[] = [
          {
            cells: [
              { value: nom_inf, ...ctx.headerCellConfig, colSpan: table_width }
            ],
            height: ctx.headerRowsHeight,
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
          {
            cells: [
              //{ value: "VEHÍCULO", ...ctx.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              { value: "PERIODO",  ...ctx.subHeaderPeriodHeaderConfig, colSpan: table_width },
            ],
            height: ctx.subHeaderHeight
          },
          {
            cells: [
              // { value: table_data[0][1], ...ctx.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              { value: ctx.period, ...ctx.subHeaderPeriodContentConfig, colSpan: table_width },
            ],
            height: ctx.subHeaderContentHeight
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.subHeaderContentRowSpan, ctx.subHeaderContentHeight),
        ];

        /* Table Body */

        var cellsCampos = [];

        //----------- CABECERA ------------
        cellsCampos.push({ value: "Ítem", ...ctx.colHeaderConfig });
        cellsCampos.push({ value: "Código", ...ctx.colHeaderConfig });
        cellsCampos.push({ value: "Placa", ...ctx.colHeaderConfig });

        //if (ctx.chkDateHour) {}

        cellsCampos.push({ value: "Estado GPS", ...ctx.colHeaderConfig });
        cellsCampos.push({ value: "Estado Cipia", ...ctx.colHeaderConfig });
        cellsCampos.push({ value: "Fatiga 360", ...ctx.colHeaderConfig });
        cellsCampos.push({ value: "Caredrive", ...ctx.colHeaderConfig });
        cellsCampos.push({ value: "ADAS", ...ctx.colHeaderConfig });
        cellsCampos.push({ value: "CAN", ...ctx.colHeaderConfig });


        rows.push({
          cells: cellsCampos,
          height: ctx.colsHeaderHeight
        });

        //----------- CONTENIDO / FILAS ------------
        table_data[1].forEach((item: { codigo: any; placa: any; estado: any; estado_cipia: any
          last_gps_fecha: any; last_gps_tipo_evento: any;
          last_fatiga360_fecha: any; last_fatiga360_tipo_evento: any;
          last_caredrive_fecha: any; last_caredrive_tipo_evento: any;
          last_adas_fecha: any; last_adas_tipo_evento: any;
          last_can_fecha: any; last_can_tipo_evento: any;
          duracion: string; }, index: number) => {

          var cellsCuerpo = [];

          codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.codigo??'').toString().length);
          placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.placa??'').toString().length);
          estado_cell_ch_width = Math.max(estado_cell_ch_width, (item.estado??'').toString().length);
          estado_cipia_cell_ch_width = Math.max(estado_cipia_cell_ch_width, (item.estado_cipia??'').toString().length);

          fatiga_cell_ch_width = Math.max(fatiga_cell_ch_width, (item.last_fatiga360_tipo_evento == '-'? '':item.last_fatiga360_tipo_evento + ctx.w_date_and_hour ).toString().length);
          caredrive_cell_ch_width = Math.max(caredrive_cell_ch_width, (item.last_caredrive_tipo_evento == '-'? '':item.last_caredrive_tipo_evento + ctx.w_date_and_hour).toString().length);
          adas_cell_ch_width  = Math.max(adas_cell_ch_width, (item.last_adas_tipo_evento == '-'? '':item.last_adas_tipo_evento + ctx.w_date_and_hour ).toString().length);

          can_cell_ch_width   = Math.max(can_cell_ch_width, (item.last_can_tipo_evento??'').toString().length);

          
          cellsCuerpo.push({ value: index + 1, ...ctx.bodyRowsConfig });

          //if (ctx.chkDateHour) { }

          cellsCuerpo.push({ value: item.codigo, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.placa, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.estado, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.estado_cipia, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.last_fatiga360_fecha+'-'+item.last_fatiga360_tipo_evento, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.last_caredrive_fecha+'-'+item.last_caredrive_tipo_evento, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.last_adas_fecha+'-'+item.last_adas_tipo_evento, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.last_can_tipo_evento, ...ctx.bodyRowsConfig });

          rows.push({
            cells:cellsCuerpo,
            height: ctx.bodyRowsHeight,
          });
        });

        // //********************************************* excel version 2 *********************************
        if ( vrs == 2 ) {
          rows.splice(0, ctx.headerRowSpan);
          rows.push(...ctx.spaceBetweenTables);
          allRows = allRows.concat(rows);
        }

        // //********************************************* excel version 1 *********************************

        /* Ancho de Columnas */

        if( vrs == 1 ){
          column_config = [
            { width: ctx.w_item },
            { width: ctx.calculateColWidth(codigo_cell_ch_width) },
            { width: ctx.calculateColWidth(placa_cell_ch_width) },
          ];
       
          column_config.push(
            { width: ctx.calculateColWidth(estado_cell_ch_width) },
            { width: ctx.calculateColWidth(estado_cipia_cell_ch_width) },
            { width: ctx.calculateColWidth(fatiga_cell_ch_width) },
            { width: ctx.calculateColWidth(caredrive_cell_ch_width) },
            { width: ctx.calculateColWidth(adas_cell_ch_width) },
            { width: ctx.calculateColWidth(can_cell_ch_width) },
          );

          /* Fin Ancho de Columnas */

          exportFileEx.push({
            freezePane: {
                rowSplit: ctx.headerRowSpan + ctx.subHeaderContentRowSpan + 2
              },
            columns: column_config,
            title: nom_vehi,
            rows: rows
          });

          codigo_cell_ch_width = "codigo".length;
          placa_cell_ch_width = "placa".length;
          estado_cell_ch_width = "Estado GPS".length;
          estado_cipia_cell_ch_width = "Estado Cipia".length;
          fatiga_cell_ch_width = "Fatiga 360".length;
          caredrive_cell_ch_width = "Caredrive".length;
          adas_cell_ch_width = "ADAS".length;
          can_cell_ch_width = "CAN".length;
        }


      } // if si hay datos del vehiculo
    });

    //NOTA: width * 1.28 (aprox) = Ancho de columna en excel

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;

      column_config = [
            { width: ctx.w_item },
            { width: ctx.calculateColWidth(codigo_cell_ch_width) },
            { width: ctx.calculateColWidth(placa_cell_ch_width) },
      ];

      column_config.push(
            { width: ctx.calculateColWidth(estado_cell_ch_width) },
            { width: ctx.calculateColWidth(estado_cipia_cell_ch_width) },
            { width: ctx.calculateColWidth(fatiga_cell_ch_width) },
            { width: ctx.calculateColWidth(caredrive_cell_ch_width) },
            { width: ctx.calculateColWidth(adas_cell_ch_width) },
            { width: ctx.calculateColWidth(can_cell_ch_width) },
      );

      exportFileEx.push({
        freezePane: {
            rowSplit: ctx.headerRowSpan
          },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });

    }


    console.log("===>exportFileEx getFileExportOperatividadEquipos", exportFileEx);  
        
    if (bol_datos_ex) {
        return exportFileEx;
    } else {
        return [];
    }

}